import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template"]

  connect() {
    const keyFields = this.rowsTarget.querySelectorAll("[data-new-contact-key-field]")
    const serials = Array.from(keyFields).map((field) => {
      const match = String(field.value || "").match(/^new-(\d+)$/)
      return match ? Number(match[1]) : null
    }).filter((serial) => serial !== null)

    this.nextRowSerial = serials.length ? Math.max(...serials) + 1 : keyFields.length
    this.ensureAnySelfSelected()
  }

  addRow() {
    const rowKey = `new-${this.nextRowSerial}`
    this.nextRowSerial += 1

    const html = this.templateTarget.innerHTML.replaceAll("__ROW_KEY__", rowKey)
    const wrapper = document.createElement("div")
    wrapper.innerHTML = html.trim()

    const row = wrapper.firstElementChild
    if (!row) return

    this.rowsTarget.appendChild(row)
    this.ensureAnySelfSelected()
  }

  removeRow(event) {
    const button = event.target.closest("[data-remove-contact-row-button]")
    if (!button) return

    const row = button.closest("[data-new-contact-row]")
    if (!row) return

    row.remove()
    this.ensureAnySelfSelected()
  }

  toggleArchive(event) {
    const button = event.target.closest("[data-existing-contact-archive-toggle]")
    if (!button) return

    const row = button.closest("[data-existing-contact-row]")
    if (!row) return

    const archiveField = row.querySelector("[data-existing-contact-archive-field]")
    if (!archiveField) return

    const participationCheckbox = row.querySelector("[data-existing-contact-participation]")
    const participationLocked = participationCheckbox?.dataset.existingContactParticipationLocked === "true"
    const isArchiving = archiveField.disabled

    archiveField.disabled = !isArchiving

    row.classList.toggle("border-rose-200", isArchiving)
    row.classList.toggle("bg-rose-50", isArchiving)
    row.classList.toggle("opacity-80", isArchiving)
    row.classList.toggle("border-slate-200", !isArchiving)
    row.classList.toggle("bg-slate-50", !isArchiving)

    const note = row.querySelector("[data-existing-contact-archive-note]")
    if (note) note.classList.toggle("hidden", !isArchiving)

    const editableFields = row.querySelectorAll("input[type='text']")
    editableFields.forEach((field) => {
      field.disabled = isArchiving
    })

    if (participationCheckbox) {
      participationCheckbox.disabled = isArchiving || participationLocked
      if (isArchiving) {
        participationCheckbox.checked = false
      }
    }

    button.textContent = isArchiving ? "削除を取り消す" : "削除"
    button.classList.toggle("border-rose-300", !isArchiving)
    button.classList.toggle("text-rose-600", !isArchiving)
    button.classList.toggle("hover:bg-rose-50", !isArchiving)
    button.classList.toggle("border-slate-300", isArchiving)
    button.classList.toggle("text-slate-600", isArchiving)
    button.classList.toggle("hover:bg-slate-50", isArchiving)
  }

  ensureAnySelfSelected() {
    const radios = this.rowsTarget.querySelectorAll("[data-new-contact-self-radio]")
    if (!radios.length) return

    const checked = Array.from(radios).find((radio) => radio.checked)
    if (!checked) radios[0].checked = true
  }
}
